import { makeStyles } from '@material-ui/core/styles';

export const getStyles = (theme) => ({
  inline: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    width: '100%',
    display: 'block',
    overflow: 'hidden',
  },
  wrapperTruncate: {
    width: '100%',
  },
  inlineButton: {
    width: '100%',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    cursor: 'default',
    color: theme.palette.blue.dark,
    margin: 0,
    '&:focus': {
      outline: 'none',
      boxShadow: 'none',
    },
  },
});

export const createStyles = makeStyles(getStyles);
